import * as ex from "excalibur";
import { CONFIG } from "../config";
const HIGHLIGHT_COLOR = ex.Color.fromRGB(255, 196, 64, 1);
const HIGHLIGHT_DURATION_MS = 2000;
const PULSE_HALF_PERIOD_MS = 400;
// Temporary "look here" marker for GameScene.focusBuilding — a diamond outline matching the
// tile footprint, pulsing via alpha, auto-removed after HIGHLIGHT_DURATION_MS. Never mutates the
// tile's own shared/cached terrain graphic (see docs/excalibur.md) — this is a separate overlay
// actor positioned at tile.center, same lifecycle idiom as BuildDustEffect.
export class TileHighlight extends ex.Actor {
    constructor(scene, tile) {
        super({ pos: tile.center, anchor: ex.vec(0.5, 0.5) });
        const w = CONFIG.TILE_WIDTH;
        const h = CONFIG.TILE_HEIGHT;
        // Only the two near (bottom) edges of the tile's diamond footprint — left→bottom→right.
        // A building sprite rises well above the tile, so the far (top) edges would be drawn
        // straight through its walls/roof; the near edges sit at its base and read correctly.
        this.graphics.use(new ex.Canvas({
            width: w,
            height: h,
            cache: true,
            draw: (ctx) => {
                ctx.strokeStyle = HIGHLIGHT_COLOR.toString();
                ctx.lineWidth = 3;
                ctx.lineJoin = "round";
                ctx.beginPath();
                ctx.moveTo(0, h / 2);
                ctx.lineTo(w / 2, h);
                ctx.lineTo(w, h / 2);
                ctx.stroke();
            },
        }));
        // Draw above ground and any buildings, same convention as BuildDustEffect.
        this.transform.z = tile.get(ex.TransformComponent).pos.y + 1e6;
        // Never intercept clicks — pure overlay, same opt-out as Building.ts.
        this.pointer.useGraphicsBounds = false;
        this.pointer.useColliderShape = false;
        scene.add(this);
        this.actions.repeatForever((ctx) => {
            ctx.fade(0.3, PULSE_HALF_PERIOD_MS).fade(1, PULSE_HALF_PERIOD_MS);
        });
        setTimeout(() => this.kill(), HIGHLIGHT_DURATION_MS);
    }
}
